import React from 'react';
import { cn } from '@/lib/utils';

interface PageContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

/**
 * Standard page-level padding wrapper used by all organization and settings pages.
 * Provides responsive padding (tighter on mobile) and bottom clearance for
 * floating UI elements (e.g. help button).
 */
export function PageContainer({ className, children, ...props }: PageContainerProps) {
  return (
    <div className={cn('p-4 sm:p-8 pb-24', className)} {...props}>
      {children}
    </div>
  );
}
